import { z } from 'zod';
import { accountWithMetaSchema, scopeSchema } from './models.js';
import { profileWithMetaSchema } from './internal.js';
export const authorizationSchema = z.object({
    identities: z.object({
        profile: z.string().optional(),
        account: z.string().optional(),
        service: z.string().optional(),
    }),
    scopes: z.array(scopeSchema),
});
export const authorizationDataSchema = z.object({
    profile: profileWithMetaSchema.optional(),
    account: accountWithMetaSchema.optional(),
    service: z.string().optional(),
    scopes: z.array(scopeSchema),
});
